import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';

function CustomerMetricsChart() {
  const [visibleSeries, setVisibleSeries] = useState(['Converted', 'Non-Converted Visits']);

  const zones = ['Electronics', 'Mobile', 'Gaming', 'Computers', 'Accessories', 'Other'];
  const totalVisits = [150, 120, 98, 85, 70, 45];
  // const converted = [95, 65, 43, 38, 25, 15];
  const converted = [];
  // const nonConverted = totalVisits.map((total, index) => total - converted[index]);
  const nonConverted = [];

  const shouldShowTotalAnnotations = visibleSeries.length === 2;

  const data = {
    series: [
      { name: 'Converted', data: converted },
      { name: 'Non-Converted Visits', data: nonConverted }
    ],
    options: {
      chart: {
        type: 'bar',
        height: 400,
        stacked: true,
        toolbar: { show: false },
        events: {
          legendClick: function (chartContext, seriesIndex, opts) {
            const series = opts.config.series[seriesIndex].name;
            setVisibleSeries((prev) => (prev.includes(series) ? prev.filter((s) => s !== series) : [...prev, series]));
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 7,
          barHeight: '75%'
        }
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val
      },
      stroke: {
        width: 1,
        colors: ['[#ffbf00]ff']
      },
      grid: {
        xaxis: { lines: { show: false } }
      },
      yaxis: {
        title: { text: 'Zones' }
      },
      tooltip: {
        shared: true,
        intersect: false,
        custom: function ({ dataPointIndex }) {
          const zone = zones[dataPointIndex];
          const total = totalVisits[dataPointIndex];
          const convertedCount = converted[dataPointIndex];
          const nonConvertedCount = nonConverted[dataPointIndex];
          const percentage = ((convertedCount / total) * 100).toFixed(1);

          return `
            <div class="p-2">
              <div class="font-bold mb-1">${zone}</div>
              <div>Total Visits: ${total}</div>
              <div>Converted: ${convertedCount} (${percentage}%)</div>
              <div>Non-Converted: ${nonConvertedCount}</div>
            </div>
          `;
        }
      },
      xaxis: {
        categories: zones,
        title: { text: 'Number of Customers' }
      },
      colors: ['#44BE54', '#FC5A83'], // Updated to better blue shades
      legend: {
        position: 'top',
        offsetY: 10
      },
      annotations: {
        points: shouldShowTotalAnnotations
          ? totalVisits.map((total, index) => ({
              x: total + 2, // Moves "Total" label slightly more to the right
              y: zones[index],
              marker: { size: 0 },
              label: {
                borderColor: '#333',
                offsetX: 30, // Moves label towards the middle
                style: {
                  color: '#333',
                  background: 'transparent',
                  padding: '1px 5px' // Adds 1px padding between border and bar
                },
                text: `Total: ${total}`
              }
            }))
          : []
      }
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '400px' }}>
      <ReactApexChart options={data.options} series={data.series} type="bar" height={400} />
    </div>
  );
}

export default CustomerMetricsChart;
